import React from "react";
import { Link } from "react-router-dom";
import Newsletter from "./Newsletter";
import { TRUSTPILOT_PROFILE_URL } from "../data";

const socialLinks = [
  {
    name: "Facebook",
    href: "https://www.facebook.com/profile.php?id=61594121594165",
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5">
        <path d="M22 12.06C22 6.5 17.52 2 12 2S2 6.5 2 12.06c0 5 3.66 9.15 8.44 9.94v-7.03H7.9v-2.91h2.54V9.85c0-2.51 1.49-3.9 3.77-3.9 1.09 0 2.24.2 2.24.2v2.46h-1.26c-1.24 0-1.63.77-1.63 1.56v1.87h2.78l-.45 2.91h-2.33V22c4.78-.79 8.44-4.94 8.44-9.94Z" />
      </svg>
    ),
  },
  {
    name: "LinkedIn",
    href: "https://www.linkedin.com/company/mantle-tech-solutions-ltd/",
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5">
        <path d="M20.45 20.45h-3.56v-5.57c0-1.33-.02-3.03-1.85-3.03-1.85 0-2.14 1.45-2.14 2.94v5.66H9.34V9h3.42v1.56h.05c.48-.9 1.64-1.85 3.38-1.85 3.6 0 4.27 2.37 4.27 5.46v6.28ZM5.34 7.43a2.06 2.06 0 1 1 0-4.12 2.06 2.06 0 0 1 0 4.12ZM7.12 20.45H3.56V9h3.56v11.45Z" />
      </svg>
    ),
  },
];

export default function Footer() {
  return (
    <footer className="bg-purple-900 text-purple-200">
      <div
        className="h-1 w-full"
        style={{
          background:
            "linear-gradient(90deg, #f3e8ff 0%, #a855f7 50%, #581c87 100%)",
        }}
      />
      <div className="container px-5 py-12 mx-auto flex flex-wrap md:flex-row md:flex-nowrap flex-col gap-10">
        <div className="w-full md:w-1/3">
          <Link to="/" className="flex items-center title-font font-medium text-white">
            <img
              src="/logo-mantle.svg"
              alt="Mantle Tech Solutions"
              className="w-8 h-8"
            />
            <span className="ml-3 text-xl">Mantle Tech Solutions</span>
          </Link>
          <p className="mt-3 text-sm leading-relaxed">
            Senior engineering, modern software, real business outcomes.
          </p>
          <div className="flex gap-3 mt-4">
            {socialLinks.map((social) => (
              <a
                key={social.name}
                href={social.href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={social.name}
                className="w-9 h-9 flex items-center justify-center rounded-full bg-purple-800 border border-purple-700 text-purple-200 hover:bg-purple-700 hover:text-white transition-colors"
              >
                {social.icon}
              </a>
            ))}
          </div>
          <div className="mt-5">
            <h2 className="title-font font-semibold text-white tracking-widest text-sm mb-2">
              STAY IN THE LOOP
            </h2>
            <Newsletter />
          </div>
        </div>

        <div className="flex-grow flex flex-wrap md:justify-end -mb-10 md:text-left text-center gap-16">
          <div className="lg:w-1/4 md:w-1/2 w-full">
            <h2 className="title-font font-semibold text-white tracking-widest text-sm mb-3">
              SITE
            </h2>
            <nav className="list-none space-y-2">
              <li>
                <Link to="/#services" className="hover:text-white">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/#solution-packs" className="hover:text-white">
                  Solution Packs
                </Link>
              </li>
              <li>
                <Link to="/#who-we-help" className="hover:text-white">
                  Who We Help
                </Link>
              </li>
              <li>
                <Link to="/#projects" className="hover:text-white">
                  Our Work
                </Link>
              </li>
              <li>
                <Link to="/blog" className="hover:text-white">
                  Insights
                </Link>
              </li>
              <li>
                <Link to="/#faq" className="hover:text-white">
                  FAQ
                </Link>
              </li>
              <li>
                <Link to="/#contact" className="hover:text-white">
                  Contact
                </Link>
              </li>
              <li>
                <a
                  href={TRUSTPILOT_PROFILE_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-white"
                >
                  Reviews on Trustpilot
                </a>
              </li>
            </nav>
          </div>

          <div className="lg:w-1/4 md:w-1/2 w-full">
            <h2 className="title-font font-semibold text-white tracking-widest text-sm mb-3">
              CONTACT
            </h2>
            <p className="leading-relaxed">
              Cambourne Business Park
              <br />
              Cambridge, UK CB23 6DW
            </p>
            <a
              href="mailto:hello@mantletechsolutions.com"
              className="block mt-2 hover:text-white"
            >
              hello@mantletechsolutions.com
            </a>
            <p className="mt-1">+44(0)7741368555</p>
          </div>
        </div>
      </div>
      <div className="border-t border-purple-800">
        <div className="container mx-auto py-4 px-5 flex flex-wrap flex-col sm:flex-row text-sm text-center justify-center">
          <p>
            © {new Date().getFullYear()} Mantle Tech Solutions. All rights
            reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
